const { BAR_CHART_CREDIT, BAR_CHART_ACCOUNT_DEBIT, LINE_CHART_COLOR } = require('constants/charts');

module.exports = {
    CHART_PROPS: {
        dataXaxis:"date",
        dataChart:["debitAmount", "creditAmount"],
        dotData:["debitAmount", "creditAmount"],
        colorChart:[BAR_CHART_ACCOUNT_DEBIT, BAR_CHART_CREDIT],
        typeChart:["BAR", "BAR"],
        typeChartBrush:["AREA"],
        typeXaxis:"date",
        formatTime:"MMM YY",
        referenceLineColor: LINE_CHART_COLOR,
        showBrush:false,
        showReferenceLineTop:false,
        showReferenceLineBottom:false,
        showDot:[false],
        lineStrokeWidth:1,
        showLegend:false,
        stackedChart: true,
        showTooltip: true,
        strokeDashCartesian:"0 0",
        showVerticalCartesianGrid:false,
        tooltipTitles:['debitAmount','creditAmount'],
        dotTooltipData:['debitAmount','creditAmount'],
        dotTooltip:[true,true]
    },
    DEBIT_LEGEND: "debitLegend",
    CREDIT_LEGEND: "creditLegend",
    COMPARE_YEARS_LEGEND: "compareYears",
    CHECK_FILTERS: [
        {
            idName: "debitLegend",
            colorLegend: BAR_CHART_ACCOUNT_DEBIT
        },
        {
            idName: "creditLegend",
            colorLegend: BAR_CHART_CREDIT
        },
        {
            idName: "compareYears",
            colorLegend: LINE_CHART_COLOR
        }
    ]
}
